// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"efc79ceefe020ac2b4b7","966":"42226413fcddb0ba52ab"}[chunkId] + ".js";
};